// Studio is available to all signed-in users.
// The backend verifies authentication and creation ownership.

export function canAccessStudio(user) {
  const username =
    typeof user?.username === 'string'
      ? user.username.trim()
      : '';

  return username.length > 0;
}
